module.exports = __webpack_public_path__ + "static/img/5.daf5fc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/5.png
// module id = jZva
// module chunks = 0